import { IcX } from "@app/components/icons";
// import useOnClickOutside from "@core/hooks/use-on-click-outside.hook";
import { useRef } from "react";
import { ModalProps } from "./modal.type";

function ModalDialogTemplate({ props }: { props: ModalProps }) {
  const {
    children,
    buttonCancelInChildren = true,
    buttonCancelInScreen = false,
    onCancel,
  } = props;

  const handleCancel = () => {
    onCancel();
  };

  const contentRef = useRef(null);

  // useOnClickOutside(contentRef, () => {
  //   onCancel();
  // });

  return (
    <div className="fixed left-0 top-0 z-[90] flex h-full w-full items-center justify-center bg-[rgba(5,10,20,.5)] p-4 [-webkit-overflow-scrolling:touch] transform-gpu">
      <div
        className="relative z-[80] max-h-full overflow-auto rounded-2xl bg-surface text-fg"
        ref={contentRef}
      >
        {children}

        {buttonCancelInChildren && (
          <button
            type="button"
            aria-label="Đóng"
            className="absolute right-4 top-4 z-[100] grid h-8 w-8 place-items-center rounded-lg border border-line bg-surface text-fg hover:bg-surface-2"
            onClick={handleCancel}
          >
            <IcX className="h-4 w-4" />
          </button>
        )}
      </div>

      {buttonCancelInScreen && (
        <button
          type="button"
          aria-label="Đóng"
          className="absolute right-2 top-2 grid h-8 w-8 place-items-center rounded-lg text-white"
          onClick={handleCancel}
        >
          <IcX className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export default ModalDialogTemplate;
